module.exports = __webpack_public_path__ + "static/media/EIGHT.5977dbb0.png";